import SalonSettingsPage from "@/main/components/features/salon_settings/SalonSettingsPage"

const SalonSettings = () => {
	return <SalonSettingsPage />
}

export default SalonSettings
